import { defineMessages } from 'react-intl';

export const scope = 'app.components.ComplianceRequirementsTooltip';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Compliance',
  },
  requirementsCount: {
    id: `${scope}.requirementsCount`,
    defaultMessage:
      '{count, plural, one {# requirement} other {# requirements}}',
  },
  compliant: {
    id: `${scope}.compliant`,
    defaultMessage: 'Compliant',
  },
  pendingReview: {
    id: `${scope}.pendingReview`,
    defaultMessage: 'Pending Review',
  },
  notCompliant: {
    id: `${scope}.notCompliant`,
    defaultMessage: 'Not Compliant',
  },
  unknownRequirement: {
    id: `${scope}.unknownRequirement`,
    defaultMessage: 'Unknown requirement',
  },
});
